import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  modalSpacing: {
    padding: '2.4rem 6.4rem 4rem 6.4rem',
  },
  body: {
    font: {
      family: 'Lato, sans-serif',
    },
    width: '100%',
    textAlign: 'center',
    '@media(max-width: 450px)': {
      width: 'auto',
    },
  },
  title: {
    font: {
      size: '2.8rem',
      lineHeight: '4rem',
    },
    letterSpacing: '0.02rem',
    marginBottom: '0.4rem',
  },
  subtitle: {
    font: {
      size: '1.6rem',
      lineHeight: '2.4rem',
    },
    letterSpacing: '0.02rem',
    margin: '0',
    color: colors.neutral[700],
    padding: '0.4rem 0 3.6rem 0',
  },
  form: { borderTop: `0.1rem solid ${colors.neutral[300]}`, marginBottom: '4.6rem' },
  inputContainer: {
    display: 'flex',
    flexDirection: 'raw',
    justifyContent: 'space-between',
    margin: '3.6rem 0 2.6rem 0',
  },
  formZipCodeInput: { width: '22%' },
  formCountyInput: { width: '44%' },
  formStateInput: { width: '27%' },
  inputSearchComponent: {
    textAlign: 'left',
    marginTop: '3.6rem',
    '& > ul': {
      position: 'static',
      marginTop: '1rem',
    },
  },
  formSelect: { width: '100%', marginTop: '3.6rem', textAlign: 'left' },
  footer: {
    margin: [0],
    marginTop: '0.4rem',
    padding: { top: '4rem' },
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderTop: '0.1rem solid #C1C7CD',
  },
  actionsBlock: {
    margin: [0],
    width: '42.4rem',
    display: 'flex',
    justifyContent: 'space-between',
  },
  toastMessage: {
    width: '80%',
    left: '10%',
    right: '20%',
    boxSizing: 'border-box',
  },
  ineligibleStateMessage: {
    margin: '0',
    fontSize: '1.6rem',
    color: colors.red[500],
  },
  ineligibleSicCodeMessage: {
    marginTop: '1.6rem',
    textAlign: 'left',
    fontSize: '1.6rem',
    color: colors.red[500],
  },
};

const createStyles = createUseStyles(styles);

export { styles, createStyles };
